// 2_components/header_left_to_free_shipping.js
// Reads the Shoptet dataLayer cart info and toggles body.has-free-shipping,
// setting the --free-shipping-progress CSS variable on #cart-widget.

export function init() {
	document.addEventListener("DOMContentLoaded", function () {
		calculateFreeShipping();
	});

	document.addEventListener("ShoptetDOMCartContentLoaded", function () {
		calculateFreeShipping();
		document.body.classList.add("cart-widget-has-loaded");
	});
}

function calculateFreeShipping() {
	if (
		!window.dataLayer[0].shoptet.cartInfo ||
		typeof window.dataLayer[0].shoptet.cartInfo.freeShipping === "undefined"
	) {
		console.warn("Cart info or freeShipping is not available in the data layer.");
		return;
	}

	const freeShippingBoolean = window.dataLayer[0].shoptet.cartInfo.freeShipping;
	if (freeShippingBoolean == true) {
		document.body.classList.add("has-free-shipping");
	}
	if (freeShippingBoolean == false) {
		document.body.classList.remove("has-free-shipping");

		const cartWidget = document.querySelector("#cart-widget");
		if (!cartWidget) {
			return;
		}
		let percentageProgressToFreeShipping = 0;
		let leftToFreeShipping = window.dataLayer[0].shoptet.cartInfo.leftToFreeShipping.priceLeft || 0;
		let cartTotal = window.dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withVat || 0;

		leftToFreeShipping = Math.round(leftToFreeShipping);
		cartTotal = Math.round(cartTotal);

		percentageProgressToFreeShipping = 100 - Math.round((leftToFreeShipping / (cartTotal + leftToFreeShipping)) * 100);
		cartWidget.style.setProperty("--free-shipping-progress", percentageProgressToFreeShipping + "%");
		if (leftToFreeShipping <= 0) {
			document.body.classList.add("has-free-shipping");
		}
	}
}
